import { render, staticRenderFns } from "./BaseAnnotationsManager.vue?vue&type=template&id=43d4b4d0&scoped=true"
import script from "./BaseAnnotationsManager.vue?vue&type=script&lang=js"
export * from "./BaseAnnotationsManager.vue?vue&type=script&lang=js"
import style0 from "./BaseAnnotationsManager.vue?vue&type=style&index=0&id=43d4b4d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d4b4d0",
  null
  
)

export default component.exports